module.exports = __webpack_public_path__ + "img/harvester.765f68bd.png";